import Carousel from 'react-material-ui-carousel';
import React from 'react';
import { Box, Typography } from '@mui/material';
import { experimental_sx as sx } from '@mui/material';
import { styled } from '@mui/material';

const Banner_Box = {
  margin: '0 auto',
  zindex: 999,
  flex: 1,
  width: '100%',
  height: '158px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
  overflow: 'hidden',
  border: ' 0px white solid',
  boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.15)',
  background: 'white',
  borderRadius: '16px',
};

const Triangle1Box = styled(Box)(({ myColor }) =>
  sx({
    zIndex: 1,
    position: 'absolute',
    width: { sm: '639.57px', xs: '300px' },
    height: '642px',
    left: { sm: '-367px', xs: '-300px' },
    top: { sm: '-54px', xs: '-20px' },
    backgroundColor: myColor,
    transform: 'rotate(41.3deg)',
    overflow: 'hidden',
  })
);

const Triangle2Box = styled(Box)(({ myColor }) =>
  sx({
    zIndex: 1,
    position: 'absolute',
    width: '176px',
    height: '237px',
    left: { sm: '142px', xs: '-5px' },
    top: '-192px',
    background: myColor,
    transform: { sm: 'rotate(-499deg)', xs: 'rotate(-501deg)' },
  })
);

export default function BannerSlider({
  content,
  primaryColor,
  secondaryColor,
}) {
  return (
    <>
      <Carousel
        data-testid="carousel"
        navButtonsAlwaysInvisible={true}
        indicatorIconButtonProps={{
          style: {
            color: secondaryColor,
          },
        }}
        activeIndicatorIconButtonProps={{
          style: {
            color: primaryColor,
          },
        }}
        animation="slide">
        {content?.map((item, i) => (
          <Item key={i} item={item} />
        ))}
      </Carousel>
    </>
  );

  function Item(props) {
    return (
      <Box sx={Banner_Box}>
        <Triangle1Box myColor={primaryColor} />
        <Triangle2Box myColor={secondaryColor} />
        <Box
          component="img"
          data-testid="banner-img"
          sx={{
            maxWidth: '180px',
            height: '140px',
            zIndex: '3',
            position: 'absolute',
            left: { sm: 70, xs: 5 },
            bottom: 0,
          }}
          src={props.item.image}
        />

        <Box
          sx={{
            zIndex: 4,
            position: 'absolute',
            mr: 1,
            left: { xs: 160, sm: 350 },
            display: 'flex',
            flexDirection: 'column',
          }}>
          <Typography
            sx={{
              typography: { sm: 'title', xs: 'titleMobile' },
              flexWrap: 'wrap',
            }}>
            {props.item.title}
          </Typography>
          <Typography
            data-testid="banner-description"
            sx={{
              typography: { sm: 'bannerDescription', xs: 'bannerMobile' },
              width: '100%',
            }}>
            {props.item.description}
          </Typography>
        </Box>
      </Box>
    );
  }
}
